import { Link } from "react-router-dom";

// Logo von Nova (2026-10-22): Silber/Violett, freigestellt, direkt auf hellem Grund
export const Logo = ({ gross = false }) => (
  <Link to="/" data-testid="nav-logo" aria-label="CHEMARA – Startseite" className="flex items-center gap-2.5 min-w-0">
    <img
      src="/assets/logo-farbig.png"
      alt=""
      className={`shrink-0 object-contain ${gross ? "h-14 w-14" : "h-10 w-10"}`}
      style={{ filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.18))" }}
      draggable="false"
    />
    <span className={`font-heading text-stein-900 tracking-[0.18em] font-medium ${gross ? "text-3xl" : "text-base sm:text-lg"}`}>
      CHEMARA
    </span>
  </Link>
);
